var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 42q-3.25 0-5.5-2.275T10 34.25V16.8q-1.75-.65-2.875-2.075Q6 13.3 6 11.5q0-2.3 1.625-3.9T11.55 6q2.25 0 3.85 1.6t1.6 3.9q0 1.8-1.125 3.225T13 16.8v17.45q0 1.95 1.375 3.35Q15.75 39 17.8 39q2 0 3.35-1.4t1.35-3.35v-20.5q0-3.25 2.25-5.5T30.25 6q3.25 0 5.5 2.25t2.25 5.5V31.2q1.75.65 2.875 2.075Q42 34.7 42 36.5q0 2.25-1.6 3.875T36.5 42q-2.25 0-3.875-1.625T31 36.5q0-1.8 1.125-3.25T35 31.2V13.75q0-2-1.375-3.375T30.25 9q-2 0-3.375 1.375T25.5 13.75v20.5q0 3.2-2.25 5.475Q21 42 17.75 42Zm-6.2-28q1 0 1.725-.75.725-.75.725-1.8 0-1-.725-1.725Q12.55 9 11.5 9q-1 0-1.75.725T9 11.5q0 1 .75 1.75t1.8.75Zm25 25q1 0 1.725-.75.725-.75.725-1.8 0-1-.725-1.725Q37.55 34 36.5 34q-1 0-1.75.725T34 36.5q0 1 .75 1.75t1.8.75ZM11.5 11.5Zm25 25Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.ba17d5ef3d3b8a52af7d048a2a8444f8.svg";
export { ForwardRef as ReactComponent };